// removed by extract-text-webpack-plugin
module.exports = {"logo":"src-components-Logo----index-module---logo---rMc3D","img":"src-components-Logo----index-module---img---2A2Ws","imgtext":"src-components-Logo----index-module---imgtext---1fD3f"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/index.module.css
// module id = 325
// module chunks = 114276838955818